import type { ReactNode } from 'react';

interface Props {
  name: string;
  value: string;
  unit?: string;
  sub?: ReactNode;
  loading?: boolean;
}

/** Scorecard tile: Fraunces serif numeric value with gold hover micro-glow and muted unit. */
export function KpiCard({ name, value, unit, sub, loading }: Props) {
  if (loading) return <div className="kpi skeleton" style={{ minHeight: 118 }} aria-busy="true" />;
  return (
    <div className="kpi group relative overflow-hidden transition-all duration-300 hover:border-gold-a28 hover:shadow-[0_8px_30px_rgba(240,164,49,0.08)]">
      <div className="name">{name}</div>
      <div className="val">
        {value}
        {unit ? <u>{unit}</u> : null}
      </div>
      {sub ? <div className="kpi-sub">{sub}</div> : null}
    </div>
  );
}
